module.exports = __webpack_public_path__ + "exo-latin-100italic.09b8eba1e3ca26851758.svg";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-100italic.svg
// module id = ../../../../typeface-exo/files/exo-latin-100italic.svg
// module chunks = styles